export const API_ENDPOINT = 'https://bijeljinaput-api.novamedia.agency';